import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen p-4">
      <div className="max-w-md w-full bg-red-50 rounded-lg p-6 text-center">
        <div className="flex justify-center">
          <ExclamationTriangleIcon className="h-12 w-12 text-red-600" />
        </div>
        <h3 className="mt-2 text-lg font-medium text-red-800">Error</h3>
        <p className="mt-1 text-sm text-red-700">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;